export default [
  {
    id: 1,
    dpi: 203,
    name: 'Test Label Template',
    size_unit: "inches",
    width: 3,
    height: 2
  },
]